/* eslint-disable @typescript-eslint/ban-ts-comment */
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import Select from "@mui/material/Select";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { useState } from "react";

import Card from "web/Components/mui/Card";
import Counter from "web/Components/mui/Counter";
import Dialog from "web/Components/mui/Dialog";

import { useAppContext } from "web/context/app";

const steps = [
  "Wybór dokumentów",
  "Dane",
  "Zgody i oświadczenia",
  "Podsumowanie",
];

const StyleGuide = () => {
  /**
   * stepper logic
   */
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set<number>());

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  /**
   * end of stepper logic
   */

  /**
   * dialog logic
   */
  const { isMobile } = useAppContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  /**
   * end of dialog logic
   */

  return (
    <>
      <Box sx={{ p: 4, maxWidth: 800, mx: "auto" }}>
        <Typography variant="h1" gutterBottom textAlign="center">
          Style guide
        </Typography>
        {/* Typography Section */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Typography
          </Typography>
          <Box>
            <Typography variant="h1">H1 Heading</Typography>
            <Typography variant="h2">H2 Heading</Typography>
            <Typography variant="h3">H3 Heading</Typography>
            <Typography variant="subtitle1">Subtitle 1</Typography>
            <Typography variant="subtitle2">Subtitle 2</Typography>
            <Typography variant="body1">Body 1</Typography>
            <Typography variant="body2">Body 2</Typography>
            <Typography variant="caption" display="block">
              Caption Text
            </Typography>
            <Typography variant="overline">Overline Text</Typography>
          </Box>
        </Paper>

        {/* Buttons Section */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Button
          </Typography>

          {/* Text Buttons */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1">Text Buttons</Typography>
            <Box sx={{ display: "inline-flex", flexWrap: "wrap", gap: 2 }}>
              <Button size="small">Small</Button>
              <Button size="medium">Medium</Button>
              <Button size="large">Large</Button>
            </Box>
          </Box>

          {/* Outlined Buttons */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1">Outlined Buttons</Typography>
            <Box sx={{ display: "inline-flex", flexWrap: "wrap", gap: 2 }}>
              <Button variant="outlined" size="small">
                Small
              </Button>
              <Button variant="outlined" size="medium">
                Medium
              </Button>
              <Button variant="outlined" size="large">
                Large
              </Button>
            </Box>
          </Box>

          {/* Contained Buttons */}
          <Box>
            <Typography variant="subtitle1">Contained Buttons</Typography>
            <Box sx={{ display: "inline-flex", flexWrap: "wrap", gap: 2 }}>
              <Button variant="contained" size="small">
                Small
              </Button>
              <Button variant="contained" size="medium">
                Medium
              </Button>
              <Button variant="contained" size="large">
                Large
              </Button>
            </Box>
          </Box>
        </Paper>

        {/* Inputs Section */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Inputs
          </Typography>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Text
            </Typography>

            <TextField
              label="Label"
              variant="outlined"
              size="medium"
              fullWidth
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Select
            </Typography>

            <FormControl size="medium" variant="outlined" fullWidth>
              <InputLabel id="select-label">Label</InputLabel>
              <Select
                labelId="select-label"
                id="select-demo"
                label="Label"
                defaultValue={10}
              >
                <MenuItem value={10}>Ten</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Checkbox
            </Typography>
            <div>
              <FormControlLabel
                control={<Checkbox />}
                labelPlacement="end"
                label="Checkbox Label"
              />
            </div>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Checkbox error
            </Typography>
            <div>
              <FormControlLabel
                control={<Checkbox color="error" />}
                labelPlacement="end"
                label="Checkbox Error Label"
              />
            </div>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h5" gutterBottom>
              Radio
            </Typography>
            <div>
              <FormControlLabel
                control={<Radio />}
                labelPlacement="end"
                label="Label"
              />
            </div>
          </Box>
        </Paper>

        {/* Card */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Card
          </Typography>
          <Card sx={{ minWidth: 275, mb: 2 }} type="primary">
            <CardContent>
              <Typography variant="h3" component="div">
                Primary
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ minWidth: 275, mb: 2 }} type="secondary">
            <CardContent>
              <Typography variant="h3" component="div">
                Secondary
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ minWidth: 275, mb: 2 }} type="error">
            <CardContent>
              <Typography variant="h3" component="div">
                Error
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ minWidth: 275, mb: 2 }} type="shadow">
            <CardContent>
              <Typography variant="h3" component="div">
                Shadow
              </Typography>
            </CardContent>
          </Card>
        </Paper>

        {/* Divider */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Divider
          </Typography>
          <Divider />
          <Typography variant="body1" gutterBottom>
            Text under divider
          </Typography>
        </Paper>

        {/* Datepicker */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Datepicker
          </Typography>

          <Typography variant="h6" gutterBottom>
            Desktop
          </Typography>
          <DesktopDatePicker label="Data urodzenia" />
          <Typography variant="h6" gutterBottom>
            Mobile
          </Typography>
          <MobileDatePicker
            label="Data urodzenia"
            localeText={{
              toolbarTitle: "Data urodzenia",
            }}
          />
        </Paper>

        {/* Counter */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Counter
          </Typography>
          <Counter />
        </Paper>

        {/* Dialog */}
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Modal/Dialog
          </Typography>
          <Button variant="contained" onClick={() => setDialogOpen(true)}>
            Otwórz modal
          </Button>
          <Dialog
            fullScreen={isMobile}
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            title="Przykładowy modal"
            actions={
              <>
                <Button
                  onClick={() => setDialogOpen(false)}
                  variant="outlined"
                  color="primary"
                  size="large"
                >
                  Anuluj
                </Button>
                <Button
                  onClick={() => setDialogOpen(false)}
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Zatwiedź swój wybór
                </Button>
              </>
            }
          >
            Przykładowa treść modala
          </Dialog>
        </Paper>
      </Box>
      <Box sx={{ width: "80%", mx: "auto" }}>
        <Typography variant="h4" gutterBottom textAlign="center">
          Stepper
        </Typography>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};

            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </>
        ) : (
          <>
            <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleNext}>
                {activeStep === steps.length - 1 ? "Finish" : "Next"}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

export default StyleGuide;
